//angular imports
import { 
  ChangeDetectionStrategy, 
  Component, 
  input 
} from '@angular/core';

//local imports
import { Transforms } from '@shared/helpers/transforms';

@Component({
    selector: 'filter-group-header',
    templateUrl: './filter-group-header.component.html',
    styleUrl: './filter-group-header.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FilterGroupHeaderComponent {

  public groupName = input<string>();  
  
  public isRoot = input(false, {
    transform: Transforms.toBoolean
  });

}
